/**
 * Where the server lives, and how each surface finds it.
 *
 * One place, so the tablet shell, the phone shell and the browser cannot drift
 * apart. HTTPS is not optional: `getUserMedia`, service workers and
 * `DeviceOrientationEvent` (the qibla compass) all require a SECURE CONTEXT, and
 * a plain http:// LAN origin is not one — it fails silently rather than loudly.
 */
export const DOMAIN = 'office.sotech.website'
export const API_BASE = `https://${DOMAIN}/api`
export const APP_BASE = `https://${DOMAIN}`

/** Overridable for local development without touching the shells. */
export function apiBase(): string {
  const override = (globalThis as { __OFFICE_API__?: string }).__OFFICE_API__
  if (override) return override
  if (typeof location !== 'undefined' &&
      (location.hostname === 'localhost' || location.hostname === '127.0.0.1')) {
    // 127.0.0.1, NOT localhost: on macOS `localhost` resolves to ::1 first, the
    // API binds IPv4 only (correct, since nginx fronts it in production), and
    // Chrome does not fall back the way curl does. The failure surfaces as a
    // misleading CORS error rather than a connection refusal.
    return 'http://127.0.0.1:8080'
  }
  return API_BASE
}
